import { Link } from "react-router-dom";
import { ArrowUpRight, DeviceMobile } from "@phosphor-icons/react";
import { EDITION, isIndia, isEdu } from "@/lib/edition";
import { EMAILS } from "@/lib/emails";

const COMPANY = [
  { label: "About", to: "/about" },
  { label: `Why ${EDITION.brand}`, to: "/why-alumnipulse" },
  { label: "Meet the Founder", to: "/founder" },
  { label: "Alumni Impact", to: "/impact" },
  { label: "Articles", to: "/articles" },
];
const SUPPORT = [
  { label: "Support", to: "/support" },
  { label: "Contact", to: "/contact" },
  { label: "Get the App", to: "/install" },
];
const LEGAL = [
  { label: "Terms of Service", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Cookie Policy", to: "/cookie" },
  { label: "Memorial & Obituary Policy", to: "/memorial-policy" },
];

const Col = ({ title, items }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{title}</p>
    <ul className="mt-3 space-y-2">
      {items.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="text-sm text-muted-foreground hover:text-foreground" data-testid={`appfooter-${l.to.slice(1)}`}>
            {l.label === "Get the App" ? <span className="inline-flex items-center gap-1 font-medium text-secondary">{l.label}<DeviceMobile size={13} weight="fill" /></span> : l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

// Global footer for signed-in (app) pages — legal, about, contact, get-app.
export default function AppFooter() {
  return (
    <footer className="mt-16 border-t border-border/60 bg-muted/30 pb-[calc(env(safe-area-inset-bottom)+72px)] sm:pb-0" data-testid="app-footer">
      <div className="mx-auto max-w-7xl px-5 py-10">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          <div className="col-span-2 sm:col-span-1">
            <Link to="/dashboard" className="flex items-center gap-2">
              {isIndia || isEdu
                ? <img src={EDITION.logo} alt={EDITION.brand} className="h-10 w-10 rounded-lg object-contain" />
                : <img src="/alumnipulse-logo.png" alt="AlumniPulse" className="h-11 w-auto" />}
              <span className="font-heading text-base font-semibold">{EDITION.brand}{EDITION.mark}</span>
            </Link>
            <p className="mt-3 max-w-xs text-sm text-muted-foreground">Your class. Your memories. Your community — for years to come.</p>
            {(isIndia || isEdu) && (
              <a href={EDITION.other.url} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1 text-sm text-secondary hover:underline" data-testid="appfooter-global-link">
                Visit {EDITION.other.label} (global)<ArrowUpRight size={13} />
              </a>
            )}
          </div>
          <Col title="Company" items={COMPANY} />
          <Col title="Help" items={SUPPORT} />
          <Col title="Legal" items={LEGAL} />
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 border-t border-border/60 pt-6 sm:flex-row sm:justify-between">
          <p className="text-xs text-muted-foreground">{EDITION.copyright}</p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground" data-testid="appfooter-emails">
            <a href={`mailto:${EMAILS.info}`} className="hover:text-secondary">{EMAILS.info}</a>
            <a href={`mailto:${EMAILS.contact}`} className="hover:text-secondary">{EMAILS.contact}</a>
            <a href={`mailto:${EMAILS.privacy}`} className="hover:text-secondary">{EMAILS.privacy}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
